export default __webpack_public_path__ + "static/media/background.fb39457e.jpg";